module.exports = "/assets/site/images/search_menu_icon.png?a0782a892ff8beecd08eb456ce986541";